import React, { Component } from 'react';

import Wrapper from '../../../hoc/Wrapper/Wrapper';
import Backdrop from '../Backdrop/Backdrop';

import classes from './DropDown.module.css';

import iconDropdownBlue from '../../../assets/icons/dropdown-arrow-blue.png';

// Props List :-
// itemList = List of menu items in the dropdown. For eg, [{id: , label:}, ...]
// dropDownOpen = boolean to  represent open/close state of dropdown
// activeItem = selected item from the dropdown list
// onDropDownItemClicked = Handles the click of dropdown item
// onDropDownClicked = Handles the click of dropdown

class DropDown extends Component {
    state = {
        dropDownOpen: false,
        activeItem: -1,
    }

    componentDidMount() {
        if (this.props.activeItem > -1) {
            this.setState({ activeItem: this.props.activeItem })
        }
    }

    onDropDownClicked = () => {
        const updatedState = !this.state.dropDownOpen;
        this.setState({ dropDownOpen: updatedState });
    }

    onDropDownItemClicked = (pos) => {
        this.setState({ activeItem: pos, dropDownOpen: false });
        this.props.onDropDownItemClicked(pos);
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.activeItem !== this.props.activeItem) {
            if (this.props.activeItem === -1) {
                this.setState({ activeItem: -1 });
            } else if (this.props.activeItem === 'reset' && this.props.resetDropDown) {
                this.setState({ activeItem: 0 });
            }
        }
    }

    render() {
        const padding = (this.props.forPage !== undefined && this.props.forPage !== null && this.props.forPage === 'VideoPlaylist')
            ? (this.state.dropDownOpen ? "16px" : "0px")
            : "16px";

        const labelFontSize = this.props.labelFontSize !== undefined ? this.props.labelFontSize : "0.875em";
        const dropdownItemFontSize = this.props.dropdownItemFontSize !== undefined ? this.props.dropdownItemFontSize : "0.8em";


        const itemList = this.props.itemList.map((item, pos) => {
            return <p
                key={pos}
                style={{ fontSize: dropdownItemFontSize }}
                className={[classes.DropDownListItem, this.props.forRevenueTab ? classes.ForRevenueTab : '', (pos === this.state.activeItem) ? classes.Active : null].join(' ')}
                onClick={() => this.onDropDownItemClicked(pos)}>
                {item.label}
            </p>
        });

        return (
            <Wrapper>
                <div className={classes.Backdrop}>
                    <Backdrop visible={this.state.dropDownOpen} transparent={true} backdropClicked={this.onDropDownClicked} />
                </div>
                <div className={[classes.DropDownContainer, this.state.dropDownOpen ? classes.DropDownOpen : null, this.props.forRevenueTab ? classes.ForRevenueTab : ''].join(' ')}>
                    <div className={[classes.DropDownTopSection, this.props.forRevenueTab ? classes.ForRevenueTab : ''].join(' ')} onClick={this.onDropDownClicked} style={{ padding: padding }}>
                        <p className={[classes.Label, this.props.forRevenueTab ? classes.ForRevenueTab : ''].join(' ')} style={{ fontSize: labelFontSize }}>
                            {this.state.activeItem >= 0 ? this.props.itemList[this.state.activeItem].label :
                                this.props.forRevenueTab ? "Select Course" : "Sort By"}
                        </p>
                        <img
                            className={!this.state.dropDownOpen ? classes.DropDownIcon : classes.DropDownIconActive}
                            src={iconDropdownBlue}
                            alt="Dropdown Icon"
                        />
                    </div>

                    <div className={classes.DropDownList}>
                        {itemList}
                    </div>
                </div>
            </Wrapper>
        );
    }
}

export default DropDown;